// 此文件封装的都是一些通用方法，各位开发大佬在这个文件封装方法时记得留下姓名。

// <sincere>
// 判断数据类型 调用方式：getType( [1,2,3], 'Array') => true
function getType (obj, type) {
  var objType = Object.prototype.toString.call(obj).slice(8, -1)
  return objType == type
}

// <sincere>
// 将对象转为query字符串 调用方式：StringChangeQuery({a:1,b:2}) => '?a=1&b=2'
function StringChangeQuery (obj) {
  if (!isArray(obj, 'Object')) {
    console.log('StringChangeQuery传入的参数类型错误')
    return
  }
  var query =
    '?' +
    Object.keys(obj)
      .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]))
      .join('&')
  return query
}

// 提取特殊url指定参数 类似 http://localhost:8080?a=1/#/home?b=2
export function getUrlSpecifiedParam(paraName) {
  let url = document.location.toString()
  let replace = url.match(/#(\S*)\?/) // 获取#到？之间的一个数组
  replace && (url = url.replace(`#${replace[1]}?`, '?')) // 把url#后面的name值去掉，保留？后面的参数

  let arrObj = url.split('?')
  if (arrObj.length >= 3) {
    url = ''
    for (let i = 0, len = arrObj.length; i < len; i++) {
      url += i === 0 ? arrObj[0] + '?' : '&' + arrObj[i]
    }
    arrObj = url.split('?')
  }
  if (arrObj.length > 1) {
    let arrPara = arrObj[1].split(/[&#]/)
    let arr
    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split('=')
      if (arr != null && arr[0] == paraName) {
        return arr[1]
      }
    }
    return ''
  } else {
    return ''
  }
}

// <sincere>
// 提取浏览器url所带的参数  调用方式： getUrlParams('https://lanhuapp.com/web/#/item/board?pid=7e15af1e-6301-4f60-8efd-a4c2c5bd061e')['pid'] => '7e15af1e-6301-4f60-8efd-a4c2c5bd061e'
function getUrlParams (url) {
  url = url.substr(url.indexOf('?') + 1)
  var arr = url.split('&')
  var obj = {}
  for (var i = 0; i < arr.length; i++) {
    var key = arr[i].split('=')[0]
    var val = arr[i].split('=')[1]
    obj[key] = val
  }
  return obj
}

// <sincere>
// 解决js小数算法失精度的问题
var decimalCal = {
  // 加法
  add: function (num1, num2) {
    var r1, r2, m, n
    try {
      r1 = num1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = num2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    n = r1 >= r2 ? r1 : r2
    return ((num1 * m + num2 * m) / m).toFixed(n)
  },
  // 减法
  sub: function (num1, num2) {
    var r1, r2, m, n
    try {
      r1 = num1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = num2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    n = r1 >= r2 ? r1 : r2
    m = Math.pow(10, Math.max(r1, r2))
    return ((num1 * m - num2 * m) / m).toFixed(n)
  },
  // 乘法
  mul: function (num1, num2) {
    var m = 0
    try {
      m += num1.toString().split('.')[1].length
    } catch (e) {}
    try {
      m += num2.toString().split('.')[1].length
    } catch (e) {}
    return (
      (Number(num1.toString().replace('.', '')) *
        Number(num2.toString().replace('.', ''))) /
      Math.pow(10, m)
    )
  },

  // 除法
  div: function (arg1 = 0, arg2 = 0) {
    var t1 = 0
    var t2 = 0
    var r1
    var r2
    try {
      t1 = arg1.toString().split('.')[1].length
    } catch (e) {}
    try {
      t2 = arg2.toString().split('.')[1].length
    } catch (e) {}
    r1 = Number(arg1.toString().replace('.', ''))
    r2 = Number(arg2.toString().replace('.', ''))
    return (r1 / r2) * Math.pow(10, t2 - t1)
  }
}

// 表单验证
var validateFrom = {
  // 身份证验证 如果身份证号正确会返回一个身份信息的数组,如果有返回错误信息就直接显示
  testIdCard: function (sId) {
    if (!sId) {
      return '请输入证件号码'
    }
    sId = String(sId)
    if (!sId.match(/^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/gi)) {
      return '身份证号格式不正确'
    }

    var card_area = {
      11: '北京',
      12: '天津',
      13: '河北',
      14: '山西',
      15: '内蒙古',
      21: '辽宁',
      22: '吉林',
      23: '黑龙江',
      31: '上海',
      32: '江苏',
      33: '浙江',
      34: '安徽',
      35: '福建',
      36: '江西',
      37: '山东',
      41: '河南',
      42: '湖北',
      43: '湖南',
      44: '广东',
      45: '广西',
      46: '海南',
      50: '重庆',
      51: '四川',
      52: '贵州',
      53: '云南',
      54: '西藏',
      61: '陕西',
      62: '甘肃',
      63: '青海',
      64: '宁夏',
      65: '新疆',
      71: '台湾',
      81: '香港',
      82: '澳门',
      91: '国外'
    }
    var iSum = 0
    var info = ''
    var card_info = Array(2)
    sId = sId.replace(/x$/i, 'a')
    if (sId.length == 0) {
      return '身份证为空'
    }

    if (card_area[parseInt(sId.substr(0, 2))] == null) {
      return '非法证件，你的地区填写有错误请仔细填写'
    }
    var sBirthday =
      sId.substr(6, 4) +
      '-' +
      Number(sId.substr(10, 2)) +
      '-' +
      Number(sId.substr(12, 2))
    var d = new Date(sBirthday.replace(/-/g, '/'))
    if (
      sBirthday !=
      d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
    ) {
      return '非法证件，请仔细填写'
    }

    for (var i = 17; i >= 0; i--) {
      iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11)
    }

    if (iSum % 11 != 1 || sId.length > 19) {
      return '非法证号，请认真填写'
    }

    var age = new Date().getFullYear() - d.getFullYear()
    card_info[0] = card_area[parseInt(sId.substr(0, 2))]
    card_info[1] = sBirthday
    card_info[2] = age
    card_info[3] = sId.substr(16, 1) % 2 ? '男' : '女'
    return card_info
  },

  // 手机号验证 成功返回true 否则false
  testPhone: function (tel) {
    if (tel == '') {
      return false
    }
    if (!/^1\d{10}$/gi.test(tel)) {
      return false
    }
    return true
  },
  // 判断输入框是否为空
  isEmpty: function (val) {
    if (!val) {
      return false
    }
    return true
  }
}

// 计算年龄
export function computeAge(birthday) {
  if (birthday) {
    const now = new Date().getTime()
    const birth = new Date(birthday).getTime()
    const age = (now - birth) / (365 * 24 * 60 * 60 * 1000)
    return Math.floor(age)
  }
  return ''
}

/* 按格式输出日期 */
export function formatDate(fmt, date) {
  var o = {
    'y+': date.getFullYear(),
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  }
  // 年份格式
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      // fmt = fmt.replace(RegExp.$1, o[k])
      // 根据要求补0
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return fmt
}

export default {
  getType: getType, // 判断数据类型
  StringChangeQuery: StringChangeQuery, // 将对象转为query字符串
  getUrlParams: getUrlParams, // 提取浏览器url所带的参数
  decimalCal: decimalCal, // 此方法是个对象 解决js小数算法失精度的问题
  validateFrom: validateFrom ,// 表单验证
  formatDate
}
